define("ROOM4.CCAProductGallery.CCAProductGallery.VehicleFilter.Model", [
  "Backbone",
  "underscore",
], function (Backbone, _) {
  "use strict";

  var FACET_FIELDS = [
    {
      field: "make",
      id: "vehicleMake",
      name: "Make",
      priority: "300",
    },
    {
      field: "model",
      id: "vehicleModel",
      name: "Model",
      priority: "200",
    },
    {
      field: "year",
      id: "vehicleYear",
      name: "Year",
      priority: "100",
    },
  ];

  var FACET_IDS = _.pluck(FACET_FIELDS, "id");
  var SEO_ROUTE_FIELDS = [
    {
      field: "make",
      id: "vehicleMake",
    },
    {
      field: "model",
      id: "vehicleModel",
    },
    {
      field: "year",
      id: "vehicleYear",
    },
  ];
  var SEO_QUERY_FIELDS = [
    {
      field: "year",
      id: "vehicleYear",
    },
    {
      field: "make",
      id: "vehicleMake",
    },
    {
      field: "model",
      id: "vehicleModel",
    },
  ];

  function trimValue(value) {
    return value === null || value === undefined ? "" : String(value).trim();
  }

  function compareValues(left, right) {
    var leftNumber = parseInt(left, 10);
    var rightNumber = parseInt(right, 10);

    if (!isNaN(leftNumber) && !isNaN(rightNumber)) {
      return rightNumber - leftNumber;
    }

    if (left < right) {
      return -1;
    }

    if (left > right) {
      return 1;
    }

    return 0;
  }

  function decodeFacetValue(value) {
    if (_.isArray(value)) {
      value = value[0];
    }

    value = trimValue(value);

    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  function slugifyVehiclePathValue(value) {
    return trimValue(value)
      .replace(/\//g, "~")
      .replace(/\(/g, "%28")
      .replace(/\)/g, "%29")
      .replace(/ /g, "_");
  }

  function encodeVehiclePathSegment(value, lowercase) {
    var slug = slugifyVehiclePathValue(value);

    if (lowercase) {
      slug = slug.toLowerCase();
    }

    return encodeURIComponent(slug);
  }

  function decodeVehiclePathSegment(value) {
    var decodedValue = trimValue(value);

    try {
      decodedValue = decodeURIComponent(decodedValue);
    } catch (error) {
      decodedValue = trimValue(value);
    }

    return decodedValue
      .replace(/%28/g, "(")
      .replace(/%29/g, ")")
      .replace(/~/g, "/")
      .replace(/_/g, " ");
  }

  function normalizeSelectedFilters(selectedFilters) {
    selectedFilters = selectedFilters || {};

    return {
      year: trimValue(selectedFilters.year),
      make: trimValue(selectedFilters.make),
      model: trimValue(selectedFilters.model),
    };
  }

  function makeOptions(values, selectedValue) {
    var optionValues = values.slice(0);

    selectedValue = trimValue(selectedValue);
    optionValues.sort(compareValues);

    return _.map(optionValues, function (value) {
      return {
        label: value,
        value: value,
        isSelected: value === selectedValue,
      };
    });
  }

  function hasCompleteVehicleFilters(selectedFilters) {
    selectedFilters = normalizeSelectedFilters(selectedFilters);

    return !!(
      selectedFilters.year &&
      selectedFilters.make &&
      selectedFilters.model
    );
  }

  function hasSeoVehiclePathFilters(selectedFilters) {
    selectedFilters = normalizeSelectedFilters(selectedFilters);

    return !!(
      selectedFilters.make &&
      (!selectedFilters.year || selectedFilters.model)
    );
  }

  function getSeoPathFiltersFromRouterArguments(routerArguments) {
    var selectedFilters = {};
    var routeLength;

    if (!routerArguments || !routerArguments.length) {
      return selectedFilters;
    }

    routeLength = Math.min(routerArguments.length, SEO_ROUTE_FIELDS.length);

    _.each(SEO_ROUTE_FIELDS.slice(0, routeLength), function (routeField, index) {
      selectedFilters[routeField.field] = decodeVehiclePathSegment(
        routerArguments[index]
      );
    });

    return hasSeoVehiclePathFilters(selectedFilters) ? selectedFilters : {};
  }

  function getSeoPathFiltersFromFragment(fragment) {
    var path = String(fragment || "").split("?")[0];
    var pathParts = path.replace(/^\/+/, "").split("/");
    var selectedFilters = {};
    var vehicleParts;

    if (
      pathParts[0] !== "gallery" ||
      pathParts.length < 2 ||
      pathParts.length > 4
    ) {
      return selectedFilters;
    }

    vehicleParts = pathParts.slice(1);

    _.each(SEO_ROUTE_FIELDS.slice(0, vehicleParts.length), function (routeField, index) {
      selectedFilters[routeField.field] = decodeVehiclePathSegment(
        vehicleParts[index]
      );
    });

    return hasSeoVehiclePathFilters(selectedFilters) ? selectedFilters : {};
  }

  var VehicleFilterModel = Backbone.Model.extend({
    getFacetFields: function getFacetFields() {
      return FACET_FIELDS.slice(0);
    },

    getFacetIds: function getFacetIds() {
      return FACET_IDS.slice(0);
    },

    getFieldForFacetId: function getFieldForFacetId(facetId) {
      var facetField = _.findWhere(FACET_FIELDS, {
        id: facetId,
      });

      return facetField && facetField.field;
    },

    getFacetIdForField: function getFacetIdForField(field) {
      var facetField = _.findWhere(FACET_FIELDS, {
        field: field,
      });

      return facetField && facetField.id;
    },

    encodeFacetValue: function encodeFacetValue(value, translator) {
      value = trimValue(value);

      if (!value) {
        return "";
      }

      return translator && translator.encodeComponent
        ? translator.encodeComponent(value)
        : encodeURIComponent(value);
    },

    getSeoPath: function getSeoPath(selectedFilters) {
      var pathParts;

      selectedFilters = normalizeSelectedFilters(selectedFilters);

      if (!hasSeoVehiclePathFilters(selectedFilters)) {
        return "gallery";
      }

      pathParts = ["gallery", encodeVehiclePathSegment(selectedFilters.make, true)];

      if (selectedFilters.model) {
        pathParts.push(encodeVehiclePathSegment(selectedFilters.model, true));
      }

      if (selectedFilters.model && selectedFilters.year) {
        pathParts.push(encodeVehiclePathSegment(selectedFilters.year, false));
      }

      return pathParts.join("/");
    },

    getGalleryItemPath: function getGalleryItemPath(selectedFilters, slug) {
      slug = trimValue(slug);

      if (!slug || !hasCompleteVehicleFilters(selectedFilters)) {
        return "gallery";
      }

      return (
        this.getSeoPath(selectedFilters) + "/" + encodeURIComponent(slug)
      );
    },

    getSeoPathFilters: function getSeoPathFilters(
      fragment,
      routerArguments
    ) {
      var selectedFilters =
        getSeoPathFiltersFromRouterArguments(routerArguments);

      return hasSeoVehiclePathFilters(selectedFilters)
        ? normalizeSelectedFilters(selectedFilters)
        : normalizeSelectedFilters(getSeoPathFiltersFromFragment(fragment));
    },

    getFragmentWithSeoVehicleParameters:
      function getFragmentWithSeoVehicleParameters(fragment, routerArguments) {
        var selectedFilters = this.getSeoPathFilters(fragment, routerArguments);
        var fragmentParts = String(fragment || "gallery").split("?");
        var query = fragmentParts.slice(1).join("?");
        var queryParameters = query ? query.split("&") : [];
        var parameterNames = {};

        if (!hasSeoVehiclePathFilters(selectedFilters)) {
          return fragment;
        }

        _.each(queryParameters, function (parameter) {
          var name = parameter.split("=")[0];

          if (name) {
            parameterNames[name] = true;
          }
        });

        _.each(SEO_QUERY_FIELDS, function (queryField) {
          if (
            selectedFilters[queryField.field] &&
            !parameterNames[queryField.id]
          ) {
            queryParameters.push(
              queryField.id +
                "=" +
                encodeURIComponent(selectedFilters[queryField.field])
            );
          }
        });

        return queryParameters.length
          ? "gallery?" + queryParameters.join("&")
          : "gallery";
      },

    ensureTranslatorSupport: function ensureTranslatorSupport(translator) {
      var self = this;
      var cloneMethods = [
        "cloneForFacetId",
        "cloneWithoutFacetId",
        "cloneWithoutFacets",
        "cloneForOption",
        "cloneForOptions",
        "cloneWithoutOption",
        "resetAll",
      ];

      if (!translator) {
        return translator;
      }

      translator.facetsToInclude = _.union(
        translator.facetsToInclude || [],
        FACET_IDS
      );

      if (translator._galleryVehicleFilterDecorated) {
        return translator;
      }

      translator._galleryVehicleFilterDecorated = true;

      _.each(cloneMethods, function (methodName) {
        var originalMethod = translator[methodName];

        if (!_.isFunction(originalMethod)) {
          return;
        }

        translator[methodName] = function () {
          return self.ensureTranslatorSupport(
            originalMethod.apply(this, arguments)
          );
        };
      });

      return translator;
    },

    applyFragmentToTranslator: function applyFragmentToTranslator(
      translator,
      fragment
    ) {
      var options = {};
      var self = this;

      this.ensureTranslatorSupport(translator);

      if (!translator) {
        return translator;
      }

      if (fragment && fragment.indexOf("?") !== -1) {
        options = _.reduce(
          fragment.split("?")[1].split("&"),
          function (memo, pair) {
            var parts = pair.split("=");
            var name = parts[0];
            var value = parts.slice(1).join("=");

            if (name) {
              memo[name] = decodeFacetValue(value);
            }

            return memo;
          },
          {}
        );
      }

      _.each(FACET_FIELDS, function (facetField) {
        var selectedValue = trimValue(options[facetField.id]);

        if (
          selectedValue &&
          !trimValue(translator.getFacetValue(facetField.id))
        ) {
          translator.parseFacet(
            facetField.id,
            self.encodeFacetValue(selectedValue, translator)
          );
        }
      });

      return translator;
    },

    isVehicleFacet: function isVehicleFacet(facetId) {
      return _.contains(FACET_IDS, facetId);
    },

    getSelectedFilters: function getSelectedFilters(translator) {
      var selectedFilters = {};

      _.each(FACET_FIELDS, function (facetField) {
        selectedFilters[facetField.field] = decodeFacetValue(
          translator && translator.getFacetValue
            ? translator.getFacetValue(facetField.id)
            : ""
        );
      });

      return normalizeSelectedFilters(selectedFilters);
    },

    getRequestData: function getRequestData(translator) {
      var selectedFilters = this.getSelectedFilters(translator);
      var requestData = {};

      if (selectedFilters.year) {
        requestData.vehicleYear = selectedFilters.year;
      }

      if (selectedFilters.make) {
        requestData.vehicleMake = selectedFilters.make;
      }

      if (selectedFilters.model) {
        requestData.vehicleModel = selectedFilters.model;
      }

      return requestData;
    },

    getTranslatorForSelectedFilters: function getTranslatorForSelectedFilters(
      translator,
      selectedFilters
    ) {
      var nextTranslator = this.ensureTranslatorSupport(translator);
      var self = this;
      var currentPage =
        translator && translator.getOptionValue
          ? translator.getOptionValue("page")
          : "";

      selectedFilters = normalizeSelectedFilters(selectedFilters);

      if (!nextTranslator) {
        return nextTranslator;
      }

      _.each(FACET_FIELDS, function (facetField) {
        nextTranslator = self.ensureTranslatorSupport(
          nextTranslator.cloneWithoutFacetId(facetField.id)
        );
      });

      _.each(FACET_FIELDS, function (facetField) {
        var selectedValue = selectedFilters[facetField.field];

        if (selectedValue) {
          nextTranslator = self.ensureTranslatorSupport(
            nextTranslator.cloneForFacetId(
              facetField.id,
              self.encodeFacetValue(selectedValue, nextTranslator)
            )
          );
        }
      });

      if (currentPage) {
        nextTranslator = this.ensureTranslatorSupport(
          nextTranslator.cloneForOption("page", currentPage)
        );
      }

      return nextTranslator;
    },

    getAvailableValues: function getAvailableValues(
      vehicleRows,
      selectedFilters,
      field
    ) {
      var valuesByName = {};
      var values = [];

      selectedFilters = normalizeSelectedFilters(selectedFilters);

      _.each(vehicleRows || [], function (row) {
        var year = trimValue(row.year);
        var make = trimValue(row.make);
        var model = trimValue(row.model);
        var value;

        if (field !== "year" && selectedFilters.year && year !== selectedFilters.year) {
          return;
        }

        if (field !== "make" && selectedFilters.make && make !== selectedFilters.make) {
          return;
        }

        if (field !== "model" && selectedFilters.model && model !== selectedFilters.model) {
          return;
        }

        value = field === "year" ? year : field === "make" ? make : model;

        if (value && !valuesByName[value]) {
          valuesByName[value] = true;
          values.push(value);
        }
      });

      return values;
    },

    clearUnavailableFilters: function clearUnavailableFilters(
      vehicleRows,
      selectedFilters,
      changedField
    ) {
      selectedFilters = normalizeSelectedFilters(selectedFilters);

      if (
        changedField !== "year" &&
        selectedFilters.year &&
        this.getAvailableValues(vehicleRows, selectedFilters, "year").indexOf(
          selectedFilters.year
        ) === -1
      ) {
        selectedFilters.year = "";
      }

      if (
        changedField !== "make" &&
        selectedFilters.make &&
        this.getAvailableValues(vehicleRows, selectedFilters, "make").indexOf(
          selectedFilters.make
        ) === -1
      ) {
        selectedFilters.make = "";
      }

      if (
        changedField !== "model" &&
        selectedFilters.model &&
        this.getAvailableValues(vehicleRows, selectedFilters, "model").indexOf(
          selectedFilters.model
        ) === -1
      ) {
        selectedFilters.model = "";
      }

      return selectedFilters;
    },

    getOptions: function getOptions(vehicleRows, selectedFilters, field) {
      return makeOptions(
        this.getAvailableValues(vehicleRows, selectedFilters, field),
        normalizeSelectedFilters(selectedFilters)[field]
      );
    },

    getFacetLabels: function getFacetLabels(vehicleRows, translator) {
      var self = this;
      var selectedFilters = this.getSelectedFilters(translator);

      return _.map(FACET_FIELDS, function (facetField) {
        var valuesByUrl = {};
        var values = [];
        var addValue = function (label) {
          var url;

          label = trimValue(label);

          if (!label) {
            return;
          }

          url = self.encodeFacetValue(label, translator);

          if (!valuesByUrl[url]) {
            valuesByUrl[url] = true;
            values.push({
              internalid: url,
              label: label,
              name: url,
              url: url,
            });
          }
        };

        _.each(vehicleRows || [], function (row) {
          addValue(row[facetField.field]);
        });

        addValue(selectedFilters[facetField.field]);

        return {
          id: facetField.id,
          name: facetField.name,
          url: facetField.id,
          values: values,
        };
      });
    },

    getSidebarFacets: function getSidebarFacets(vehicleRows, translator) {
      var self = this;
      var selectedFilters = this.getSelectedFilters(translator);

      return _.map(FACET_FIELDS, function (facetField) {
        var valuesByUrl = {};
        var values = [];
        var addValue = function (label) {
          var url;

          label = trimValue(label);

          if (!label) {
            return;
          }

          url = self.encodeFacetValue(label, translator);

          if (!valuesByUrl[url]) {
            valuesByUrl[url] = true;
            values.push({
              internalid: url,
              label: label,
              name: url,
              url: url,
            });
          }
        };

        _.each(
          makeOptions(
            self.getAvailableValues(
              vehicleRows || [],
              selectedFilters,
              facetField.field
            ),
            selectedFilters[facetField.field]
          ),
          function (option) {
            addValue(option.value);
          }
        );

        addValue(selectedFilters[facetField.field]);

        return {
          id: facetField.id,
          name: facetField.name,
          url: facetField.id,
          values: values,
        };
      });
    },

    getSearchUrl: function getSearchUrl(translator, selectedFilters) {
      var nextTranslator = this.ensureTranslatorSupport(translator);
      var self = this;

      selectedFilters = normalizeSelectedFilters(selectedFilters);

      _.each(FACET_FIELDS, function (facetField) {
        nextTranslator = self.ensureTranslatorSupport(
          nextTranslator.cloneWithoutFacetId(facetField.id)
        );
      });

      nextTranslator = this.ensureTranslatorSupport(
        nextTranslator.cloneWithoutOption("page")
      );

      _.each(FACET_FIELDS, function (facetField) {
        var selectedValue = selectedFilters[facetField.field];

        if (selectedValue) {
          nextTranslator = self.ensureTranslatorSupport(
            nextTranslator.cloneForFacetId(
              facetField.id,
              self.encodeFacetValue(selectedValue, nextTranslator)
            )
          );
        }
      });

      return nextTranslator.getUrl();
    },

    getSeoUrl: function getSeoUrl(url, selectedFilters, translator) {
      var parts = String(url || "").split("?");
      var query = parts.slice(1).join("?");
      var queryParameters = query ? query.split("&") : [];
      var vehicleParameterNames = {};

      selectedFilters = normalizeSelectedFilters(selectedFilters);

      if (!hasSeoVehiclePathFilters(selectedFilters)) {
        return url;
      }

      _.each(SEO_QUERY_FIELDS, function (queryField) {
        vehicleParameterNames[queryField.id] = true;
      });

      queryParameters = _.filter(queryParameters, function (parameter) {
        var parameterName = parameter.split("=")[0];

        return !vehicleParameterNames[parameterName];
      });

      queryParameters = _.map(
        _.filter(SEO_QUERY_FIELDS, function (queryField) {
          return !!selectedFilters[queryField.field];
        }),
        function (queryField) {
          return (
            queryField.id +
            "=" +
            (translator && translator.encodeComponent
              ? translator.encodeComponent(selectedFilters[queryField.field])
              : encodeURIComponent(selectedFilters[queryField.field]))
          );
        }
      ).concat(queryParameters);

      return (
        "/" +
        this.getSeoPath(selectedFilters) +
        (queryParameters.length ? "?" + queryParameters.join("&") : "")
      );
    },
  });

  VehicleFilterModel.getFacetDefinitions = function getFacetDefinitions() {
    return _.map(FACET_FIELDS, function (facetField) {
      return {
        id: facetField.id,
        url: facetField.id,
        name: facetField.name,
        priority: facetField.priority,
        behavior: "single",
        collapsed: true,
        isParameter: true,
      };
    });
  };

  return VehicleFilterModel;
});
